var map = {
	"./draggable-tags.png": 446,
	"./tags-cloud.png": 447
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1177;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tags ^\.\/.*\.png$
// module id = 1177
// module chunks = 0